import styled, { css } from 'styled-components';
import { colors } from 'components/styles/_variables';
import { respondTo } from '../../styles/_respondTo';

export const ConfigBlock = styled.div`
  ${({ showBorder }) =>
    showBorder &&
    css`
      border-right: solid 1px #fdf2eb;
    `};
  max-width: 350px;
  flex: 1;
  min-width: 300px;
  padding-bottom: ${({ desktop_pb = 20 }) => desktop_pb}px;
  &:first-child {
    padding-left: 0 !important;
    padding-right: 32px;
    ${respondTo.smallDesktop`
      padding-right: 10px;
    `}
  }
  &:nth-child(2) {
    max-width: 400px;
    padding: 0 32px;
    ${respondTo.smallDesktop`
      // padding: 0 12px 12px 12px;
    `}
  }
  &:last-child {
    padding-left: 32px;
    ${respondTo.smallDesktop`
      // padding-top: 16px;
      // padding-left: 0px;
    `}
  }

  ${respondTo.mobile`
    padding: ${({ mobileP = '0 0 20px 0' }) => mobileP} !important;
    border-right: none !important;
    // border-bottom: solid 1px #FDF2EB;
    margin-bottom: 40px;
    min-width: 100%;
    &:last-child {
      border: none !important;
      margin-bottom: 0;
    }
  `}
`;

export const TimesFormWrapper = styled.div`
  margin-top: 40px;
  ${respondTo.mobile`
    margin-bottom: 0;
  `}
`;

export const TimeItemsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  //padding-bottom: 20px;
  margin: 20px 0;
  border-bottom: 1px solid ${colors.elements.border};

  &:last-child {
    border: none !important;
    margin: 20px 0 0 0;

    ${respondTo.mobile`
       margin: 0;
    `}
  }

  ${respondTo.mobile`
    flex-direction: column;
  `}
`;

export const ExceptionsWrapper = styled.div`
  // border-top: 1px solid ${colors.elements.border};
  padding: ${({ p = '20px' }) => p};
  margin: 0 -20px;

  ${({ isLast }) =>
    isLast &&
    css`
      ${respondTo.mobile`
        border-top: none !important;
        padding: 40px 0 20px 0 !important;
    `}
    `}

  ${respondTo.mobile`
      // border-bottom: 1px solid ${colors.elements.border};
      padding: 40px 0;
      margin: 0;
  `}
`;

export const ExceptionRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
`;
